const en = {
  agency: "National Police Agency of Mongolia",
  agencySub: "GENERAL POLICE DEPARTMENT",
  system: "Drug Crime Investigation Platform",
  searchPlaceholder: "Search case no., subject, evidence",
  userName: "Investigator B.Ganzorig",
  userOrg: "Anti-Narcotics Division, Team 2",
  notif: "Notifications",
  logout: "Log out",
  dashTitle: "Investigation Dashboard",
  dashSub: "Anti-Narcotics Division — H1 2026",
  kpiActiveCases: "Active cases",
  kpiArrests: "Arrests",
  kpiSeizure: "Total seized",
  kpiPending: "Awaiting analysis",
  kpiVsPrev: "vs. prev. quarter",
  trendTitle: "Monthly cases filed vs. arrests",
  trendCases: "Filed",
  trendArrests: "Arrests",
  byTypeTitle: "Seizure by drug type",
  byTypeUnit: "(in g)",
  statusTitle: "Case processing status",
  statusOngoing: "Under investigation",
  statusProsecuted: "Referred",
  statusClosed: "Closed",
  regionTitle: "Distribution by district",
  recentTitle: "Recent cases",
  quickActions: "Quick actions",
  qaNewCase: "New case",
  qaNewEvidence: "New evidence",
  qaRequest: "Analysis request",
  qaReport: "Create report",
  alertsTitle: "Needs attention",
  cases: "",
  persons: "",
  thisMonth: "This month",
  viewCase: "View case",
  geoTitle: "Geographic Analysis",
  geoSub: "Drug crime distribution across Ulaanbaatar districts",
  viewMarkers: "Markers",
  viewHeatmap: "Heatmap",
  geoFilterSubstance: "Drug type",
  hotspotRank: "Hotspot ranking",
  incidents: "Incidents",
  topSubstance: "Top substance",
  selectedRegion: "Selected district",
  regionIncidents: "Total incidents",
  regionActive: "Active cases",
  regionArrest: "Arrests",
  legendDensity: "Incident density",
  densityLow: "Low",
  densityHigh: "High",
  routeTitle: "Main inbound routes",
  routeSub: "Estimated border → capital trafficking routes",
  geoUpdated: "Last 90 days",
  clickRegionHint: "Click a district to view detailed statistics",
  frTitle: "Forensic Requests",
  frSub: "Narcotics, digital, biological and other forensic requests",
  frNo: "Request no.",
  frDevice: "Device",
  frTarget: "Specimen",
  frField: "Discipline",
  frResults: "Analysis results",
  catDrugF: "Narcotics",
  catDigitalF: "Digital",
  catDnaF: "Bio / DNA",
  catPrintF: "Fingerprint",
  catDocF: "Document",
  catToxF: "Toxicology",
  ftDrugQual: "Drug qualitative",
  ftDrugQuant: "Drug quantitative",
  ftUnknown: "Unknown substance ID",
  ftDna: "DNA analysis",
  ftFingerprint: "Fingerprint analysis",
  ftTox: "Toxicology analysis",
  ftDoc: "Document / handwriting",
  frType: "Analysis type",
  frRequester: "Requester",
  frAnalyst: "Analyst",
  frPriority: "Priority",
  frDate: "Requested",
  frProgress: "Progress",
  frArtifacts: "Extracted artifacts",
  frStepsTitle: "Analysis progress log",
  newRequest: "New request",
  ftExtract: "Data extraction",
  ftCalls: "Call history",
  ftMessages: "Message recovery",
  ftLocation: "Location history",
  ftRecovery: "Deleted-file recovery",
  fsReceived: "Received",
  fsAnalyzing: "Analyzing",
  fsDone: "Complete",
  fsHold: "On hold",
  priHigh: "Urgent",
  priNormal: "Normal",
  frTotal: "Total requests",
  frAnalyzingC: "Analyzing",
  frDoneC: "Complete",
  frHoldC: "On hold",
  rpTitle: "Analysis Reports",
  rpSub: "Digital forensic analysis result reports",
  rpNo: "Report no.",
  rpAuthor: "Author",
  rpDate: "Date",
  rpSecurity: "Security",
  rpTool: "Analysis tools",
  rpOverview: "Overview",
  rpFindings: "Key findings",
  rpExtracted: "Extracted data summary",
  rpCommFreq: "Contact frequency",
  rpConclusion: "Conclusion",
  rpContact: "Contact",
  rpTimes: "×",
  rpApproved: "Approved",
  rpReview: "In review",
  rpDraft: "Draft",
  sevHigh: "Critical",
  sevMid: "Caution",
  sevInfo: "Note",
  downloadPdf: "Download PDF",
  reportList: "Report list",
  mRoles: "Roles / Permissions",
  mAudit: "Audit log",
  rolesTitle: "Roles & Permissions",
  rolesSub: "Configure feature access by user role",
  addRole: "Add role",
  roleMembers: "Members",
  permMatrix: "Permissions by feature",
  permModule: "Menu / Feature",
  permView: "View",
  permCreate: "Create",
  permEdit: "Edit",
  permDelete: "Delete",
  permApprove: "Approve",
  permExport: "Export",
  modCase: "Case management",
  modEvidence: "Evidence",
  modDrug: "Drug data",
  modAnalysis: "Analysis",
  modForensic: "Forensics",
  modStats: "Statistics / Reports",
  modSystem: "System admin",
  grantedCount: "Granted",
  auditTitle: "Audit Log",
  auditSub: "System user activity records",
  colTime: "Timestamp",
  colUser: "User",
  colAction: "Action",
  colTarget: "Target",
  colModule: "Menu",
  colIp: "IP address",
  colResult: "Result",
  actLogin: "Login",
  actLogout: "Logout",
  actView: "View",
  actCreate: "Create",
  actEdit: "Edit",
  actDelete: "Delete",
  actExport: "Export",
  actPerm: "Permission change",
  resOk: "Success",
  resFail: "Failed",
  resDenied: "Denied",
  filterUser: "User",
  filterAction: "Action",
  filterResult: "Result",
  auditTotal: "Total logs",
  auditToday: "Today",
  auditDenied: "Denied",
  auditFail: "Failed",
  mInvest: "Investigation",
  mDashboard: "Dashboard",
  mDrugData: "Drug data",
  mAnalysis: "Analysis",
  mForensic: "Forensics",
  mAgency: "Agency liaison",
  mStats: "Statistics / Reports",
  mSupport: "Support",
  mSystem: "System admin",
  mMyInfo: "My info",
  mCase: "Case management",
  mSubject: "Subject management",
  mEvidence: "Evidence management",
  mRequest: "Request management",
  mSubstance: "Drug substance data",
  mSpectrum: "Spectrum references",
  mFieldData: "Field analysis data",
  mDataset: "Training datasets",
  mModel: "Model management",
  mRelation: "Network analysis",
  mGeo: "Geographic analysis",
  mStatAnalysis: "Statistical analysis",
  mForensicReq: "Forensic requests",
  mDigitalEvidence: "Digital evidence",
  mReport: "Analysis reports",
  mOtherAgency: "Other-agency data",
  mMigration: "Data migration",
  mInvStats: "Investigation stats",
  mReports: "Reports",
  home: "Home",
  list: "List",
  detail: "Detail",
  search: "Search",
  reset: "Reset",
  register: "Register",
  edit: "Edit",
  print: "Print",
  excel: "Export to Excel",
  save: "Save",
  approve: "Request approval",
  total: "Total",
  items: "",
  viewAll: "View all",
  select: "Select",
  actions: "Actions",
  period: "Period",
  status: "Status",
  type: "Type",
  all: "All",
  name: "Name",
  page: "Page",
  lastUpdated: "Last updated",
  demoNote: "This screen is a proposal demo; all data is fictitious",
  caseDetailTitle: "Case Detail",
  caseNo: "Case no.",
  caseName: "Case name",
  caseStatusActive: "Under investigation",
  tabBasic: "Basic info",
  tabDrugCard: "Drug card",
  tabPersons: "Related persons",
  tabEvidence: "Evidence",
  caseType: "Case type",
  caseTypeVal: "Drug distribution & sale",
  receivedDate: "Date filed",
  occurredDate: "Date occurred",
  occurredPlace: "Location",
  jurisdiction: "Jurisdiction",
  assignedTeam: "Assigned unit",
  leadInvestigator: "Lead investigator",
  coInvestigators: "Co-investigators",
  overview: "Case overview",
  caseOverviewText: "An organized distribution case involving the sale of methamphetamine via a private SNS chat channel across the Bayanzürkh district of Ulaanbaatar. The border-entry route is under tracing, and additional investigation of two accomplices is ongoing.",
  progressHistory: "Progress history",
  relatedRequests: "Linked requests",
  intlCoop: "Int'l cooperation",
  intlCoopVal: "UNODC information-sharing request (ongoing)",
  securityLevel: "Security level",
  securityLevelVal: "Level 2 — Investigation team only",
  h1: "Case filed and investigation opened",
  h2: "On-site search & seizure — 12 items secured",
  h3: "1 suspect arrested in emergency",
  h4: "Analysis requested — National Forensic Institute",
  h5: "Network analysis report registered",
  drugCardTitle: "Drug Card",
  drugCardNo: "Card no.",
  substanceName: "Substance",
  seizedAmount: "Seized amount",
  purity: "Purity",
  form: "Form",
  formVal: "Crystalline (crystal)",
  packaging: "Packaging",
  packagingVal: "24 portioned zip bags",
  seizureDate: "Seizure date/time",
  seizurePlace: "Seizure location",
  analysisStatus: "Analysis status",
  analysisDone: "Analysis complete",
  analysisPending: "Analysis pending",
  inboundRoute: "Inbound route (est.)",
  inboundRouteVal: "Zamyn-Üüd border → Ulaanbaatar (overland)",
  streetValue: "Street value",
  distributionMethod: "Distribution method",
  distributionMethodVal: "Private SNS chat — dead-drop method",
  relatedSubstances: "Related substance cards",
  cardCreated: "Card created",
  personRole: "Role",
  personDob: "Born",
  personAddress: "Address",
  personPhone: "Phone",
  personStatus: "Custody status",
  roleSuspect: "Suspect",
  roleAccomplice: "Accomplice",
  roleVictim: "Victim",
  roleWitness: "Witness",
  custodyArrested: "Detained",
  custodyWanted: "Wanted",
  custodyReleased: "Released",
  custodyInvestigating: "Under questioning",
  priorRecord: "Prior record",
  priorYes: "1 prior drug offense",
  priorNo: "None",
  viewRelationMap: "View network",
  evidenceNo: "Evidence no.",
  evidenceName: "Item name",
  evidenceCategory: "Category",
  storageLocation: "Storage location",
  storageStatus: "Storage status",
  chainOfCustody: "Chain of custody",
  catDrug: "Narcotics",
  catDigital: "Digital device",
  catCash: "Cash / valuables",
  catOther: "Other",
  stInStorage: "In storage",
  stAnalysis: "In analysis",
  stDisposalReq: "Disposal requested",
  stTransferred: "Transferred",
  registerEvidence: "Register evidence",
  requestDisposal: "Request disposal",
  evidenceListTitle: "Evidence Management",
  summaryTotal: "Total evidence",
  summaryInStorage: "In storage",
  summaryAnalysis: "In analysis",
  summaryDisposal: "Pending disposal",
  filterCategory: "Category",
  filterStatus: "Storage status",
  filterCase: "Case no.",
  relatedCase: "Linked case",
  registeredDate: "Registered",
  registrant: "Registrant",
  weight: "Weight / qty",
  relationTitle: "Network Analysis",
  relationSub: "Case-centric person, organization & substance network",
  targetCase: "Target case",
  depth: "Search depth",
  legend: "Legend",
  nodeCase: "Case",
  nodePerson: "Person",
  nodeOrg: "Organization",
  nodeSubstance: "Substance",
  nodePlace: "Location",
  edgeLabel: "Relation",
  selectedNode: "Selected node",
  connections: "Connections",
  addRelation: "Add relation",
  exportImage: "Save image",
  clickNodeHint: "Click a node to view its details",
  relSell: "sold",
  relSupply: "supplied",
  relMember: "member",
  relBoss: "boss",
  relBuy: "bought",
  relLocation: "operates at",
  relInvolved: "involved",
  substanceTitle: "Drug Substance Data",
  substanceListSub: "Substance reference data & spectrum library",
  casNo: "CAS no.",
  classification: "Classification",
  scheduleVal: "Psychotropic substance, Schedule I",
  aliases: "Aliases",
  refSpectra: "Reference spectra",
  fieldSamples: "Field analysis data",
  linkedCases: "Linked cases",
  spectrumViewer: "Spectrum viewer",
  spectrumType: "Instrument type",
  overlayField: "Overlay field data",
  matchScore: "Match",
  refCode: "Reference code",
  equipment: "Instrument",
  measuredDate: "Measured",
  verifyStatus: "Verification",
  verified: "Verified",
  unverified: "Pending",
  wavenumber: "Raman shift (cm⁻¹)",
  intensity: "Relative intensity",
  riskLevel: "Risk level",
  riskHigh: "High risk",
  appearance: "Appearance",
  molFormula: "Formula",
  commonNames: "Street names",
} as const;

export default en;
